// extracted by mini-css-extract-plugin
export default {"clearFix":"ClearFix_clearFix__8aMUK"};